import React, { useState, useEffect } from 'react'

// Importa las funciones de tu BL (ajusta la ruta según tu estructura)
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from './../../utilities/BL/Zones'

// Importa el componente visual hijo (el que tiene los estilos y animación)
import { Score as ScoreOverlay } from './Overlays/Score'


/**
 * COMPONENTE: SCORE OVERLAY (PARENT CONTAINER)
 * ------------------------------------------------------------------
 * Este componente es el "Cerebro" del Overlay. 
 * 1. Establece la conexión WebSocket como "overlay:marcador".
 * 2. Escucha los mensajes entrantes.
 * 3. Pasa la información al componente visual <Score />.
 * ------------------------------------------------------------------
 */
const Score = () => {
    // --- ESTADOS DE CONEXIÓN Y DATOS ---
    const [scoreData, setScoreData] = useState(null); // Payload para el hijo
    const [connectionStatus, setConnectionStatus] = useState('idle');
    
    // Opcional: Si necesitas manejar el modo femenil/varonil aquí también
    // const [isActiveWomensMode, setIsActiveWomensMode] = useState(false); 

    // -------------------------------------------------------------------------
    // CICLO DE VIDA: CONEXIÓN Y DESCONEXIÓN
    // -------------------------------------------------------------------------
    useEffect(() => {
        
        // 1. Definir la función de conexión
        const connect = async () => {
            // Llamamos a la nueva función del BL especificando 'marcador'
            await ConnectWebSocketForOverlay(
                'marcador', 
                (status) => setConnectionStatus(status),
                (msg) => console.log('[Overlay] Toast:', msg) // O tu lógica de toast
            );

            // Asignamos el manejador de mensajes
            SetSocketMessageHandler(handleIncomingMessage);
        };

        // 2. Definir el manejador de mensajes (El "Switch")
        // const handleIncomingMessage = (message) => {
        //     // 1. Log de depuración para ver qué llega exactamente
        //     console.log('[Overlay] Mensaje recibido:', message);

        //     if (!message || !message.type) return;

        //     // Filtramos solo los mensajes relevantes para marcador
        //     // 2. Filtra por los tipos definidos en el servicio C#
        //     if (message.type === 'score.state_update') {
        //         setScoreData(message); // Pasamos el objeto completo que incluye el type
        //     } else if (message.type === 'score.notification') {
        //         setScoreData(message); // Lo reutilizamos para notificaciones
        //     }
        // };

        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            if (message.type === 'score.state_update') {
                // Forzamos un objeto nuevo para que React detecte el cambio
                setScoreData({ ...message }); 
            } else if (message.type === 'score.notification') {
                setScoreData({ ...message });
            }
        };

        // 3. Ejecutar conexión
        connect();

        // 4. Cleanup al desmontar
        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
    }, []);

    // -------------------------------------------------------------------------
    // RENDERIZADO
    // -------------------------------------------------------------------------
    return (
        <>
            {/* Renderizamos el componente visual pasándole la data del socket.
                Si tuvieras lógica de Modo Femenil, pásala aquí también.
            */}
            <ScoreOverlay data={scoreData} /> {/* isActiveWomensMode={isActiveWomensMode} */}

            {/* Opcional: Indicador de error de conexión (útil para debug en OBS) */}
            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: 5, fontSize: 10 }}>D</div>
            )}
        </>
    );
};

export { Score };